/* custom-animations.js */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Aplica a classe de animação dinamicamente para as seções dentro do main
  // Ignoramos seções da primeira dobra (topo da página) ou que interagem com o cabeçalho transparente
  const sections = document.querySelectorAll('#main .shopify-section');
  
  sections.forEach((section) => {
    // Evita aplicar animação em elementos que configuram ou interagem com o cabeçalho transparente
    if (section.querySelector('[allow-transparent-header]') || section.hasAttribute('allow-transparent-header')) {
      return;
    }

    // Pega a posição do topo da seção em relação ao documento absoluto
    const sectionTop = section.getBoundingClientRect().top + window.scrollY;
    
    // Se a seção estiver localizada no topo do documento (abaixo de 250px), não a animamos
    // Isso evita problemas de carregamento no topo, melhora o LCP e protege o cabeçalho transparente
    if (sectionTop < 250) {
      return;
    }

    section.classList.add('scroll-fade-in');
  });

  // 2. Fallback de animação com IntersectionObserver para navegadores sem suporte a Scroll-Driven Animations
  const supportsScrollDriven = CSS.supports('(animation-timeline: view()) and (animation-range: entry)');

  if (!supportsScrollDriven) {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -20px 0px', // Dispara a animação quase ao entrar no viewport, maximizando a visibilidade do efeito
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Para de observar o elemento para poupar processamento
          observerInstance.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observa todas as seções que receberam a classe de animação
    document.querySelectorAll('.scroll-fade-in').forEach(el => {
      observer.observe(el);
    });
  }
});

// 3. Web Component para controle do botão "Ler mais" na descrição do produto
class ReadMoreContainer extends HTMLElement {
  connectedCallback() {
    const initReadMore = () => {
      const content = this.querySelector('.read-more-content');
      const toggle = this.querySelector('.read-more-toggle');
      if (!content || !toggle) return;

      const maxHeight = parseInt(this.getAttribute('max-height') || '200', 10);
      if (content.scrollHeight <= maxHeight + 30) {
        toggle.style.display = 'none';
        this.classList.remove('is-truncated');
      } else {
        toggle.style.display = '';
        this.classList.add('is-truncated');
      }

      if (!this._hasEventListener) {
        this._hasEventListener = true;
        toggle.addEventListener('click', () => {
          const isExpanded = this.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          const label = toggle.querySelector('.read-more-label');
          if (label) {
            label.textContent = isExpanded ? 'Ler menos' : 'Ler mais';
          }
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReadMore);
    } else {
      setTimeout(initReadMore, 100);
    }
  }
}

if (!window.customElements.get('read-more-container')) {
  window.customElements.define('read-more-container', ReadMoreContainer);
}

// 4. Controle da Animação de Brilho da Tela (Hero Shine Overlay)
(function initHeroShine() {
  const runShine = () => {
    const shineOverlay = document.getElementById('hero-shine-overlay');
    if (!shineOverlay) return;

    // Inicia a transição suave de fade-out após a animação do feixe de luz (~3.0s)
    setTimeout(() => {
      shineOverlay.classList.add('is-finished');
      
      // Remove o elemento após a conclusão da transição CSS (1200ms)
      setTimeout(() => {
        if (shineOverlay && shineOverlay.parentNode) {
          shineOverlay.parentNode.removeChild(shineOverlay);
        }
      }, 1200);
    }, 3000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runShine);
  } else {
    runShine();
  }
})();


